<template>
  <v-card :flat="flat">
    <v-card-title class="py-0">
      <h6 class="text-h6 grey--text text--darken-2 py-0">
        {{ $t('delivery.myOrder') }}
      </h6>
    </v-card-title>

    <v-divider class="mb-3"></v-divider>

    <v-card-text v-if="getItems.length == 0">
      {{ $t('delivery.emptyOrder') }}
    </v-card-text>

    <v-card-text class="pa-1">
      <template v-for="category in getCategories">
        <div v-if="hasCategoryItems(category)" :key="category.id">
          <v-list class="px-0 pt-0" dense>


            <template v-for="(item,index) in getItemsByCategory(category)">
              <customer-cart-detail-product :category="category" :item="item" :key="item.product.id"></customer-cart-detail-product>
              <v-divider :key="index"></v-divider>
            </template>

            <!--SUBTOTAL-->
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title
                    class="subtitle-1 text-right"
                    :style="{color: category.fontColor}">
                  <b>Total {{ category.name }}</b>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="mr-3">
                <v-chip
                    class="font-weight-bold"
                    :style="{backgroundColor: category.backgroundColor, color: category.fontColor}"
                >
                  {{ categoryItemsQuantity(category) }}
                </v-chip>
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>

          </v-list>


        </div>
      </template>
    </v-card-text>

    <v-card-text v-if="quantityTotal" class="py-1 text-right">
      <cart-total
          :items-amount="productsAmount"
          :delivery-cost="deliveryCost"
          :total-amount="totalAmount"
          :amount-total-with-discount="totalAmountWithDiscount"
          :discount-rate="discountRate"
          :totalDiscount="productDiscount"
      />
    </v-card-text>

    <v-card-actions >
    <customer-cart-detail-actions
        v-if="showActions"
        :is-cart-ready="isCartReady"
        :quantity-total="quantityTotal"
        @next="next"
        @close="close"
    />
    </v-card-actions>

    <v-card-text v-if="!isMinimumQuantityPerCategoryReached">
      <v-alert v-for="category in getCategoriesBelowMinimunQuantity"  type="error" :key="category.id">
        El mínimo para {{isDelivery ? 'delivery' : 'take away'}} son {{getCategoryMinimunQuantity(category)}} {{category.name}} </v-alert>
    </v-card-text>


  </v-card>
</template>

<script>

import CartTotal from "@/modules/delivery/components-core/shared/CartTotal/CartTotal";
import ProductMixin from "@/modules/delivery/mixins/ProductMixin";
import CustomerCartDetailProduct
  from "@/modules/delivery/components-core/customer/CustomerCartDetail/CustomerCartDetailProduct.vue";
import CustomerCartDetailActions
  from "@/modules/delivery/components-core/customer/CustomerCartDetail/CustomerCartDetailActions.vue";

export default {
  name: "CustomerCartDetail",
  components: {CustomerCartDetailActions, CustomerCartDetailProduct, CartTotal},
  mixins: [ProductMixin],

  props: {
    flat: {type: Boolean, default: false},
    items: {type: Array},
    showActions: {type: Boolean, default: false},
  },
  computed: {
    getCategoryMinimunQuantity() {
      return category => this.$store.getters.orderSystem.cartService.getCategoryMinimunQuantity(category.id)
    },
    getItems(){
      return this.$store.getters.orderSystem.order.items
    },
    quantityTotal(){
      return this.$store.getters.orderSystem.cartService.getItemsQuantity
    },
    deliveryCost(){
      return this.$store.getters.orderSystem.order.delivery.cost
    },
    deliveryFree(){
      return this.$store.getters.orderSystem.order.deliveryFree
    },
    productsAmount(){
      return this.$store.getters.orderSystem.cartService.getItemsAmount
    },
    discountRate(){
      return this.$store.getters.orderSystem.order.discountRate
    },
    productDiscount(){
      return this.$store.getters.orderSystem.cartService.getItemsDiscount
    },
    totalAmount(){
      return this.$store.getters.orderSystem.cartService.getTotalAmount
    },
    totalAmountWithDiscount(){
      return this.$store.getters.orderSystem.cartService.getTotalAmountWithDiscount
    },
    isDelivery(){
      return this.$store.getters.orderSystem.order.isDelivery
    },
    isCartReady(){
      return this.$store.getters.orderSystem.isCartReady
    },
    isMinimumQuantityPerCategoryReached(){
      return this.$store.getters.orderSystem.cartService.isMinimumQuantityPerCategoryReached
    },
    getCategoriesBelowMinimunQuantity(){
      return this.$store.getters.orderSystem.cartService.getCategoriesBelowMinimunQuantity
    },

    getCategories() {
      return this.$store.getters.categories
    },
    getItemsByCategory() {
      return category => {
        return this.$store.getters.orderSystem.cartService.getItemsByCategory(category)
      }
    },
    hasCategoryItems() {
      return category => {
        return this.$store.getters.orderSystem.cartService.hasCategoryItems(category)
      }
    },
    categoryItemsQuantity() {
      return category => {
        return this.$store.getters.orderSystem.cartService.getQuantityByCategory(category)
      }
    },

  },
  methods: {

    next() {
      this.$emit('next')
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

